import { render, staticRenderFns } from "./myInviteCode.vue?vue&type=template&id=0ed73b20&scoped=true"
import script from "./myInviteCode.vue?vue&type=script&lang=js"
export * from "./myInviteCode.vue?vue&type=script&lang=js"
import style0 from "./myInviteCode.vue?vue&type=style&index=0&id=0ed73b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed73b20",
  null
  
)

export default component.exports